
import Backbone from 'backbone'
import _ from 'lodash'
import appDisplay from 'scoreboard/components/app-display'
import globals from 'scoreboard/components/globals'
import i18n from 'scoreboard/components/i18n'
import config from 'scoreboard/components/config'
import permissions from 'scoreboard/components/permissions'
import ProjectOrganizationNav from 'scoreboard/components/project-organization-nav'
import TreeActions from 'scoreboard/components/tree-actions'
import EditProjectDialog from './edit-project-dialog'
import EditTreeMenu from './edit-tree-menu'
import projects from './projects'
import Project from './project'
import ProjectGardener from './projects-gardener'
import projectUpdates from './project-updates'
import metadata from 'scoreboard/components/metadata'
import { isV6 } from 'scoreboard/components/version'

/**
 * @param {Number} options.id The project id to be selected on initial load
 */
const ProjectsNav = ProjectOrganizationNav.extend({

	className : 'project-pane',

	section: 'projects',

	folders: false,

	Model: Project,

	Gardener: ProjectGardener,

	EditTreeMenu: EditTreeMenu,

	events: _.extend({}, ProjectOrganizationNav.prototype.events, {
		'click .create-first': '_new',
		'click .new': '_new'
	}),

	initialize() {
		if (isV6()) {
			this.displayTreeTopToolbar = _.constant(false)
		}
		ProjectOrganizationNav.prototype.initialize.apply(this, arguments)
	},

	_bindEvents: function() {
		ProjectOrganizationNav.prototype._bindEvents.apply(this, arguments)
		// System change (push notification, page load, bookmark navigation, etc)
		this.listenTo(Backbone, 'change:project', projectId => this._changeProject(projectId))
		this._onceTreeLoaded(data => projectUpdates.listenToTree(this.gardener))
	},

	isEditable: function(orgId) {
		return permissions.modifyProjects() && !config.replicationInputEnabled
	},

	/**
	 * @see Nav#getBottomToolbarOptions for default options
	 * @see NavBottomToolbar#initialize for all available options
	 */
	getBottomToolbarOptions() {
		const opts = ProjectOrganizationNav.prototype.getBottomToolbarOptions.apply(this, arguments)
		opts.canCollapse = false
		opts.noCollapseControl = true
		if (isV6()) {
			opts.addLabelCode = metadata[this.section].addLabelCode
		}
		return opts
	},

	/**
	 * @override
	 */
	selectCurrent() {
		this._changeProject({ silent: true }, projects.id)
	},

	renderTreeActions() {
		this.treeActions = new TreeActions({
			el: this.el,
			tree: _.get(this.gardener, 'tree'),
			buttonContent: i18n.get('common.select')
		}).render()
		this.treeActions.on('selected', projectId => this.select(projectId))
		this.on('search', this.treeActions.onSearch.bind(this.treeActions))
	},

	/**
	 * When the select button is clicked
	 */
	select(projectId) {
		// If the project pane is in edit mode, call _conditionallyShowTooltip() in order
		// to conditionally show the edit dialog needed to edit the selected project
		// on narrow screens (< constants.NAV_EDIT_MENU_CUTOFF)
		if (this.gardener.editable()) {
			this._conditionallyShowTooltip(_.result(this.gardener, 'tree.selected'))
		}

		// Let listeners know (menu-manager.js) that we've selected a project.
		this.trigger('select:project', projectId)
	},

	renderNavBottomToolbar() {
		ProjectOrganizationNav.prototype.renderNavBottomToolbar.apply(this, arguments)
		var isEditable = this.getBottomToolbarOptions().isEditable
		this.$('.bottom-toolbar').toggleClass('is-not-displayed', !isEditable)
		this.$('.tree-container').toggleClass('has-no-toolbars', !isEditable)
	},

	/**
	 * Invoked when the selected project should be updated in the tree,
	 * either as a result of user selection or navigation (e.g. page load, global search, bookmarks, etc)
	 *
	 * @param {Boolean} [options.silent=false]
	 * 	If true, only the project gardener will be updated with the active project.
	 * 	If false, the menu manager will be triggered and the org selector will be shown.
	 * 	(Required for user interactions with project selector.)
	 *
	 * @param {Number} projectId
	 */
	_changeProject(options = {}, projectId) {
		const {silent} = options
		if (projectId && this._gardenerXHRDone()) {
			this.gardener.tree.select(projectId)
		}
		// Inform the client of the change; in main.js the org pane will be swapped in
		!silent && this.trigger('change:project', _.result(this.gardener.tree, 'selected'))
	},

	_new() {
		appDisplay.dialog(new EditProjectDialog({model: new Project()}))
	},

	_gardenerXHRDone() {
		return _.get(this.gardener, 'stream.finished')
	}
})

export default ProjectsNav

ProjectsNav.__filename__ = 'projects/projects-nav.js'
